<template>
    <div id="page" style="background-color: rgba(248, 248, 248, 1);">
        <div class="container">
            <img src="~@/assets/images/menu/商厨类碳标签-声明.png" style="width: 100%;"/>
        </div>
        <section class="section"  style="background-color: rgba(241, 241, 241, 1);height: 70px;padding: 0;">
            <div class="container">
                <div class="row" style="height: 70px;display:flex;align-items: center;margin:0;" herf="/articleDetail">
                    <template v-for="item in key">
                        <div :key="item" class="col-lg-2 col-md-2 active-nav-1" :class="active==item?'active-nav':''" @click="activeChange(item)">{{item}}</div>
                    </template>
                </div>
            </div>
        </section>
        <section class="section" style="padding: 0;padding-bottom:0;"  v-show="active==key[0]">
            <!--            预留显示图文信息-->
            <div class="container" style="text-indent: 2em;">
                <span class="paragraph_1"
                ><br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;中国电子节能技术协会与中国质量认证中心采用企业自我声明+第三方审核+互联网站信息公开+社会监督+碳标签产业创新联盟的认证模式开展碳标签工作，对企业产品进行产品碳足迹声明和碳标签评价。产品通过认证后将分别获得中国质量认证中心颁发的产品碳足迹证书，中国电子节能技术协会颁发的产品碳标签评价证书和环境产品声明证书。并将成为中国碳标签产业创新联盟正式会员。</span>
            </div>
        </section>
        <section class="section" style="padding: 0;padding-bottom:0;" >
            <div class="container">
                <div class="row" style="padding:20px 0;" v-show="active==key[1]">
                    <template  v-for="(item,index) in 12">
                        <div class="col-lg-12"  :key="index">
                            <div class="text-tip-2"><span style="color:rgba(1, 90, 177, 1);font-weight: 400;">预制混凝土衬砌管片/通用环</span><span>2020-10-06</span></div>
                        </div>
                    </template>
                    <div class="mt-3">
                        <b-pagination v-model="page.currentPage" :total-rows="page.rows" align="right"></b-pagination>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    import {articleList} from "@/api/home"
    import {getSpecialTime}  from "@/utils/tools"
    export default {
        name: "menu2_2",
        data() {
            return {
                active:"低碳产品供应商简介",
                page:{
                    rows:0,
                    currentPage:1
                },
                key:["低碳产品供应商简介","产品供应商声明报告"]
            }
        },
        components: {},
        watch: {},
        mounted() {
            console.log("this.$route.params",this.$route.query)
        },
        created() {

        },
        methods: {
            getSpecialTime,
            activeChange(value){
                this.active=value
            },
            articleList(){
                let data={
                    parentTitle:"碳标签-标准制定",sonTitle:"碳标签-低碳产品声明"
                }
                articleList(data).then(res=>{
                    console.log(res)
                    this.list = res.data.records
                    this.page.rows=res.data.total
                })
            }
        }
    }
</script>

<style scoped>

    .container{
        width: 1200px;
        min-width: 375px;
    }
    .active-nav{
        height: 70px;
        background-color: rgba(2, 171, 57, 1);
        color: #ffffff;
    }
    .active-nav-1{
        height: 70px;
        line-height: 70px;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .list-content{
        width: 285px;
        background-color: #ffffff;
        padding-bottom:10px;
        margin-bottom: 15px;
    }
    .text-tip-1{
        font-family: SourceHanSansCN, SourceHanSansCN;
        font-weight: 400;
        font-size: 20px;
        color: #000000;
        line-height: 30px;
        padding: 10px 10px 5px 10px;
        height: 100px;
        line-height: 30px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3; /* 定义文本的行数 */
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .text-tip-2{
        padding: 5px 10px;
        display: flex;
        font-family: SourceHanSansCN, SourceHanSansCN;
        font-weight: 200;
        font-size: 16px;
        color: #888888;
        line-height: 30px;
    }
    .text-tip-2 span{
        flex:1;
    }
    .text-tip-2 span:nth-child(2){
        text-align: right;
    }
</style>
